import {
  IconBook,
  IconHome,
  IconCreditCard,
  IconUserCircle,
} from "@tabler/icons-react";
export const RouteList = [
  {
    link: "/d/overview",
    label: "dashboard",
    icon: IconHome,
  },

  {
    link: "/d/courses",
    label: "myLearning",
    icon: IconBook,
  },
  {
    link: "/plans",
    label: "plans",
    icon: IconCreditCard,
  },
  {
    link: "/d/account",
    label: "account",
    icon: IconCreditCard,
  },
];
